import React from 'react';

import {observer} from "mobx-react";
import {PropositionBetsWidgetAsync} from "../../../proposition-bets-widget/components/proposition-bets-widget.async";
import {ENTITY_TYPES} from "../../../../core/app/consts";
import styles from "../../styles/game-center-widget.module.scss";
import classNames from "classnames";
import {OddsByWidgetAsync} from "../../../odds-by-widget/components/odds-by-widget.async";

export const GameCenterWidgetContentPropositionBetsTab = observer(({controller, matchupId, gameId, location, showOdds}) => {
  const {state} = controller;
  const {shouldRenderPropositionBets, device: {isSmallView}} = state;

  const propositionBetsProps = {
    matchupId,
    gameId,
    location,
    showOdds,
  }

  const oddsByWidgetProps = {
    entityId: gameId,
    entityType: ENTITY_TYPES.game,
    className: classNames(styles.odds_by, {[styles.small_view]: isSmallView})
  }

  return (shouldRenderPropositionBets ? <>
    <OddsByWidgetAsync {...oddsByWidgetProps} />
    <PropositionBetsWidgetAsync {...propositionBetsProps}/>
  </> : null)
});
